import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './core/layout/layout.component';
import {authRoutes} from './pages/auth/auth.routing';
import {AuthGuard} from './services/auth_guard.service';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule),
            },
       /*     {
                path: 'vendor',
                loadChildren: () => import('./pages/user-management/vendor/vendor.module#Vendor').then(m => m.),,

            },
            {
                path: 'client',
                loadChildren: () => import('./pages/user-management/client/client.module#Client').then(m => m.),
            },*/
            {
                path: 'user',
                loadChildren: () => import('./pages/user-management/operator/operator.module').then(m => m.OperatorModule),
            },
            {
                path: 'cold-store',
                loadChildren: () => import('./pages/user-management/cold-store/cold-store.module').then(m => m.ColdStoreModule),
            },
          /*  {
                path: 'deviation-history',
                loadChildren: () => import('./pages/user-management/deviation-type/deviation-type.module#DeviationType').then(m => m.),
            },*/
            /*{
                path: 'deviation',
                loadChildren: () => import('./pages/user-management/deviation/deviation.module#Deviation').then(m => m.),
            },*/
            {
                path: 'performance',
                loadChildren: () => import('./pages/user-management/escalation/escalation.module').then(m => m.EscalationModule),
            },
            {
                path: 'region',
                loadChildren: () => import('./pages/user-management/region/region.module').then(m => m.RegionModule),
            },
            {
                path: 'site',
                loadChildren: () => import('./pages/user-management/site/site.module').then(m => m.SiteModule),
            },
            {
                path: 'settings/profile',
                loadChildren: () => import('./pages/settings/profile/profile.module').then(m => m.ProfileModule),
            },
         /*   {
                path: 'settings/roles',
                loadChildren: () => import('./pages/settings/roles/roles.module#Roles').then(m => m.),
            },
            {
                path: 'settings/users',
                loadChildren: () => import('./pages/settings/users/users.module#Users').then(m => m.),
            },*/
            {
                path: 'settings/food-type',
                loadChildren: () => import('./pages/settings/commodity/commodity.module').then(m => m.CommodityModule),
            },
            {
                path: 'settings/profile-type',
                loadChildren: () => import('./pages/settings/profile-type/profile-type.module').then(m => m.ProfileTypeModule),
            },
            {
                path: 'settings/all-roles',
                loadChildren: () => import('./pages/settings/allroles/allroles.module').then(m => m.AllRolesModule),
            },
        ]
    },
    {
        path: 'auth',
        children: [
            ...authRoutes
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})

export class AppRoutingModule {
}
